import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {Router} from '@angular/router';
import {CoreSidebarModule} from '../../../../@core/components';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {StorageService} from '../../../shared/services/storage.service';
import {SessionService} from '../../../shared/services/session.service';
import {EarningService} from '../../../shared/services/earning.service';
import {AlertService} from '../../../shared/services/alert.service';

@Component({
    selector: 'app-tour-fund-bonus',
    templateUrl: './tour-fund-bonus.component.html',
    styleUrls: ['./tour-fund-bonus.component.scss']
})
export class TourFundBonusComponent implements OnInit {
    sessions: any = [];
    filterForm: FormGroup;
    submitted: any = false;
    submitting: any = false;
    searchForm: FormGroup;
    pagination = {
        page: 1,
        total: null,
        perpage: 50,
        pages: null
    };
    modalType: any;
    tourFundBonus: any = [];
    user: any;

    constructor(private router: Router,
                private _coreSidebarService: CoreSidebarModule,
                public modalService: NgbModal,
                private fb: FormBuilder,
                private sessionService: SessionService,
                private earningService: EarningService,
                private alertService: AlertService) {
        this.user = StorageService.getItem('self');
    }

    ngOnInit(): void {
        this.refresh();
    }

    refresh() {
        this.searchForm = this.fb.group({
            'transaction_id': [''],
            'member_name': [''],
            'chargable_basic_total': [''],
            'start_date_time': [''],
            'end_date_time': ['']
        });
        this.filterForm = this.fb.group({
            'session_id': ['']
        });
        this.getSessions();
    }

    getSessions() {
        this.sessions = [];
        this.sessionService.get({'page': -1}).subscribe(data => {
            this.sessions = [];
            if (data && data['data'].length > 0) {
                this.sessions = data['data'];
                if (this.sessions && this.sessions.length > 0) {
                    this.sessions.forEach(session => {
                        if (session && session['status'] === 'ACTIVE' && session['default_session'] === 'ACTIVE') {
                            this.filterForm.patchValue({
                                'session_id': session['id']
                            });
                        }
                    });
                    this.get();
                }
            }
            this.submitting = false;
        }, error => {
            this.submitting = false;
        });
    }

    get(params: any = {}) {
        this.submitting = true;
        if (this.searchForm.value && this.searchForm.value.start_date_time && !this.searchForm.value.end_date_time) {
            this.submitting = false;
            this.alertService.showErrors('Please choose End Date');
            return false;
        } else if (this.searchForm.value && !this.searchForm.value.start_date_time && this.searchForm.value.end_date_time) {
            this.submitting = false;
            this.alertService.showErrors('Please choose Start Date');
            return false;
        }
        params.page = this.pagination.page;
        params.per_page = this.pagination.perpage;
        params.session_id = (this.filterForm.value && this.filterForm.value.session_id) ? this.filterForm.value.session_id : '';
        params.transaction_id = (this.searchForm.value && this.searchForm.value.transaction_id) ? this.searchForm.value.transaction_id : '';
        params.member_name = (this.searchForm.value && this.searchForm.value.member_name) ? this.searchForm.value.member_name : '';
        params.chargable_basic_total = (this.searchForm.value && this.searchForm.value.chargable_basic_total) ? this.searchForm.value.chargable_basic_total : '';
        params.start_date_time = (this.searchForm.value && this.searchForm.value.start_date_time) ? this.searchForm.value.start_date_time : '';
        params.end_date_time = (this.searchForm.value && this.searchForm.value.end_date_time) ? this.searchForm.value.end_date_time : '';
        this.tourFundBonus = [];
        this.earningService.getTourFundBonus(params).subscribe(data => {
            if (data && data['data'].length > 0) {
                this.tourFundBonus = data['data'];
            } else {
                this.tourFundBonus = [];
            }
            this.pagination = {
                page: data.current_page,
                total: data.total,
                perpage: data.per_page,
                pages: data.last_page,
            };
            this.submitting = false;
        }, error => {
            this.tourFundBonus = [];
            this.submitting = false;
        });
    }

    search() {
        this.get();
    }

    onPageChange(page) {
        this.pagination.page = page;
        this.get();
    }
}
